import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgentWeeklyTargetData } from "../../../redux/prospect-reducers/prospectSlice";
import {
  convertStraight,
  convertThenFormat,
  currentMonthName,
  currentMonthNumber,
  currentYear,
  TODAYS_DATE_FORMATTED,
} from "../../../components/common-data/Converts";
import CmnFilters from "../../../components/lead-management/common/CmnFilters";
import ReactVortoxSpinner from "../../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";

const AgentWeeklyReport = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const {
    agentWeeklyReportLoading,
    agentWeeklyReport,
    agentWeeklyReportError,
  } = useSelector((state) => state.prospects);

  const iniDatas = {
    pagination: [],
    allData: [],
    allDataStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const iniAllFilter = {
    selectedMonth: {
      label: currentMonthName,
      value: currentMonthNumber,
    },
    selectedYear: {
      label: currentYear,
      value: currentYear,
    },
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    month: allFilters.selectedMonth?.value || "",
    year: allFilters.selectedYear?.value || "",
    staff_id: rowData?.staff_id || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  function getAgentWeeklyTargetData(filters) {
    const { page, limit, filter_type, ...rest } = filters;

    dispatch(
      fetchAgentWeeklyTargetData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.staff_id) {
      getAgentWeeklyTargetData(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      month: allFilters.selectedMonth?.value || "",
      year: allFilters.selectedYear?.value || "",
    }));
  }, [allFilters.selectedMonth, allFilters.selectedYear]);

  useEffect(() => {
    if (
      agentWeeklyReport?.status &&
      agentWeeklyReport?.data &&
      !agentWeeklyReportLoading &&
      !agentWeeklyReportError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: agentWeeklyReport.data,
        pagination:
          agentWeeklyReport?.pagination?.length > 0
            ? agentWeeklyReport.pagination
            : [],
        allDataStats: agentWeeklyReport?.stats ? agentWeeklyReport.stats : {},
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [agentWeeklyReport, agentWeeklyReportLoading, agentWeeklyReportError]);

  const tbColumns = [
    {
      dataField: "date_added",
      text: "date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? convertStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "todays_target",
      text: `Today's (${TODAYS_DATE_FORMATTED}) target`,
      formatter: (cell, row) => {
        const isAbove =
          Number(row?.last_day_remaining || 0) <= 0 ? true : false;

        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.todays_target || 0)}
            <br />
            <small
              style={{
                color: isAbove ? "#209216" : "#E41815",
              }}
            >
              (₹
              {convertThenFormat(row?.ideal_target_total || 0)} + ₹
              {convertThenFormat(row?.last_day_remaining || 0)})
            </small>
          </span>
        );
      },
    },
    {
      dataField: "target_acheived",
      text: `Today (${TODAYS_DATE_FORMATTED}) target acheived`,
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.target_acheived || 0)}
          </span>
        );
      },
    },
    {
      dataField: "target_remaining",
      text: "target remaining",
      formatter: (cell, row) => {
        const isAbove = Number(row?.target_remaining || 0) <= 0 ? true : false;

        return (
          <span
            className="tb-data"
            style={{
              color: isAbove ? "#209216" : "#E41815",
            }}
          >
            ₹{convertThenFormat(row?.target_remaining || 0)}
            {isAbove ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-up-short"
                viewBox="0 0 16 16"
                style={{ color: "#209216" }}
              >
                <path
                  fillRule="evenodd"
                  d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down-short"
                viewBox="0 0 16 16"
                style={{ color: "#E41815" }}
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                />
              </svg>
            )}
          </span>
        );
      },
    },
    {
      dataField: "ideal_target_total",
      text: "total ideal target",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.ideal_target_total || 0)}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <CmnFilters
        from={"agent-weekly-target"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        isLoading={agentWeeklyReportLoading}
      />

      {agentWeeklyReportLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
            <PaymentLinkTable
              tableData={allDatas.allData}
              tableColumns={tbColumns}
              isFirstColSticky={true}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AgentWeeklyReport;
